
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ServicesSection from './components/ServicesSection';
import HowItWorksSection from './components/HowItWorksSection';
import TestimonialsSection from './components/TestimonialsSection';
import AboutSection from './components/AboutSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import ContactSection from './components/ContactSection';
import TrustBadges from '../../components/feature/TrustBadges';
import DebtCalculatorWidget from '../../components/feature/DebtCalculatorWidget';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Main Content */}
      <main>
        <HeroSection />
        <TrustBadges />
        
        {/* Debt Calculator Section */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                See How Much You Could Save
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Use our free calculator to estimate your potential debt savings with our proven settlement program
              </p>
            </div>
            
            <div className="max-w-lg mx-auto">
              <DebtCalculatorWidget />
            </div>
          </div>
        </section>
        
        <FeaturesSection />
        <ServicesSection />
        <HowItWorksSection />
        <TestimonialsSection />
        <AboutSection />
        <FAQSection />
        <CTASection />
        <ContactSection />
      </main>
      
      <Footer />
    </div>
  );
}
